module.exports = __webpack_public_path__ + "static/media/02-1-mobile.c2e72c6f.webp";